import type { UseDocumentResult } from '@ztechapps/common.hook'
import { useDocument } from '@ztechapps/common.hook'
import { orderListGetNetTotalQuery } from '../graphql'

export const useGetNetTotal = (filter: Record<any, any>): UseDocumentResult => {
  return useDocument({
    query: orderListGetNetTotalQuery,
    entity: 'orderListGetNetTotal',
    filter,
  })
}
